import { useCallback } from 'react';
import { CellValueChangedEvent } from 'ag-grid-community';
import { SYS2020_R01Dto } from '../Dto_SYS2020_R01';

interface UseSYS2020_R01CellChangeProps {
	updateSYS2020_R01List: (index: number, data: SYS2020_R01Dto) => void;
	originalSYS2020_R01List: SYS2020_R01Dto[];
}

export function useSYS2020_R01CellChange({
	updateSYS2020_R01List,
	originalSYS2020_R01List,
}: UseSYS2020_R01CellChangeProps) {
	const handleCellChange = useCallback(
		(event: CellValueChangedEvent<SYS2020_R01Dto>) => {
			const { data, colDef, newValue } = event;
			if (!data || !colDef.field) return;

			const field = colDef.field as keyof SYS2020_R01Dto;
			const updatedData: SYS2020_R01Dto = {
				...data,
				[field]: newValue as string,
				isModified: !data.inserted,
			};

			const originalRow = originalSYS2020_R01List.find((item) => item.valueIndex === data.valueIndex);
			if (originalRow && originalRow[field] === updatedData[field]) {
				updatedData.isModified = false;
			}

			updateSYS2020_R01List(data.valueIndex!, updatedData);
		}, [updateSYS2020_R01List, originalSYS2020_R01List]);

	return { handleCellChange };
}
